<template>
  <div>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showReminder"  width="600px" :destroy-on-close="true" append-to-body :before-close="cancel">
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="标题：" prop="title">
          <el-input style="width: 400px" v-model="form.title" placeholder="请输入提醒标题"></el-input>
        </el-form-item>
        <el-form-item label="发票记录：" prop="invoiceRecordId">
          <el-input style="width: 400px" size="small" v-model="form.invoiceRecordId" auto-complete="off" :readonly=true
                    placeholder="请获取发票记录信息">
            <template #append>
              <el-button type="primary" icon="el-icon-edit" @click="getRecord"></el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="邮寄信息：" prop="mailInfoId">
          <el-input style="width: 400px"
                    size="small" v-model="form.mailInfoId" auto-complete="off" :readonly=true
                    placeholder="请获取需要提醒的邮寄信息">
            <template #append>
              <el-button type="primary" icon="el-icon-edit" @click="getMail"></el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="频率：" prop="frequency">
          <el-select v-model="form.frequency" style="width: 400px">
            <el-option value="day" label="每天"></el-option>
            <el-option value="week" label="每周"></el-option>
            <el-option value="month" label="每月"></el-option>
            <el-option value="customized" label="自定义"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.frequency!=='customized'" label="开始日期：" prop="startDate">
          <el-input style="width: 400px" v-model="form.startDate" placeholder="请输入开始日期，格式‘YYYY-MM-DD’"></el-input>
        </el-form-item>
        <el-form-item v-if="form.frequency!=='customized'" label="次数：" prop="time">
          <el-input-number style="width: 400px" v-model="form.time" :min="1" :max="10" label="选择提醒次数"></el-input-number>
        </el-form-item>
        <el-form-item v-if="form.frequency === 'customized'" label="日期：" prop="day">
          <el-input style="width: 400px" v-model="form.day" placeholder="请输入不超过10个的逗号隔开的日期，格式‘YYYY-MM-DD’"></el-input>
        </el-form-item>
        <el-form-item  label="备注：" prop="remark">
          <el-input style="width: 400px" v-model="form.remark" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
      </div>
    </el-dialog>
    <select-record v-if="showRecordDialog" :show-dialog="showRecordDialog" @record="closeSelectRecord"></select-record>
    <select-mail v-if="showMailDialog" :show-dialog="showMailDialog" @mail="closeSelectMail"></select-mail>
  </div>
</template>

<script>


import {checkDate, checkDates} from "@/utils/rules";
import SelectRecord from "@/components/reminder/SelectRecord.vue";
import SelectMail from "@/components/reminder/SelectMail.vue";
import {addReminders, editReminders} from "@/api/dilivery/reminder";
import {padDate} from "@/store/date";

export default {
  name: "AddEditReminder",
  components: {SelectMail, SelectRecord},
  props:['showReminder','selectType','selectDetail'],
  data(){
    return{
      title:'',
      showRecordDialog:false,
      showMailDialog:false,
      form:{
        remark: '',
        frequency: '',
        startDate: '',
        day: '',
        title: '',
        time: 1,
        remindersTimes: {},
        doneFlag: 0,
        invoiceRecordId:'',
        mailInfoId:''
      },
      rules: {
        frequency: [
          { required: true, message: '频率不能为空', trigger: 'change' }
        ],
        startDate: [
          { required: true, message: '开始日期不能为空', trigger: 'change' },
          { validator:checkDate,trigger: 'change'}
        ],
        title: [
          { required: true, message: '提醒标题不能为空', trigger: 'change' }
        ],
        time: [
          { required: true, message: '次数不能为空', trigger: 'change' }
        ],
        day: [
          { required: true, message: '日期不能为空', trigger: 'change' },
          { validator:checkDates,trigger: 'change'}
        ],
        invoiceRecordId: [
          { validator: this.validateRecordOrMail, trigger: 'change'}
        ],
        mailInfoId: [
          { validator: this.validateRecordOrMail, trigger: 'change'}
        ]
      }
    }
  },
  mounted() {
    this.form.startDate = this.getCurrentDate()
  },
  watch: {
    'selectType':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          if(newVal === 'add'){
            this.title = '添加日历提醒'
          }else{
            this.title = '修改日历提醒'
          }
        }
      },
      immediate:true
    },
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.title = newVal.title
          this.form.remark = newVal.remark
          if(newVal.invoiceRecordId!==null){
            this.form.invoiceRecordId = newVal.invoiceRecordId
          }
          if(newVal.mailInfoId!==null){
            this.form.mailInfoId = newVal.mailInfoId
          }
          const Info = this.analyzeDates(newVal.remindersTimes)
          this.form.startDate = Info.startDate
          this.form.time = Info.time
          this.form.frequency = Info.frequency
          this.form.day = Info.day
        }
      },
      immediate:true
    },
  },
  methods: {
    validateRecordOrMail(rule, value, callback) {
      if (this.form.invoiceRecordId === '' && this.form.mailInfoId === '') {
        callback(new Error('发票记录和邮寄信息至少选择一个'));
      } else {
        callback();
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
      const day = date.getDate().toString().padStart(2, '0'); // 日期
      return `${year}-${month}-${day}`
    },
    analyzeDates(input) {
      const dates = Object.keys(input).map(date => new Date(date));
      const date = Object.keys(input)
      dates.sort((a, b) => a - b);
      // 找到最开始的日期
      const startDate = dates[0].toISOString().split('T')[0];
      // 计算日期增长的频率
      let frequency = 'customized';
      if (dates.length < 2) {
        // 如果日期数量小于2，无法判断频率
        frequency = 'customized';
      } else {
        // 检查是否有相同日期
        if (new Set(dates.map(date => date.toISOString().split('T')[0])).size !== dates.length) {
          frequency = 'customized';
        } else {
          // 检查每日频率
          if (dates.every((date, i, arr) => i === 0 || (date.getTime() - arr[i - 1].getTime() === 24 * 60 * 60 * 1000))) {
            frequency = 'day';
          } else {
            // 检查每周频率
            if (dates.every((date, i, arr) => i === 0 || (date.getTime() - arr[i - 1].getTime() === 7 * 24 * 60 * 60 * 1000))) {
              frequency = 'week';
            } else {
              // 检查每月频率
              if (dates.every((date, i, arr) => {
                if (i === 0) return true;
                const prevDate = arr[i - 1];
                const currDate = date;
                const daysInMonth = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 0).getDate();
                const daysDifference = (currDate.getTime() - prevDate.getTime()) / (24 * 60 * 60 * 1000);
                return daysDifference === daysInMonth;
              })) {
                frequency = 'month';
              }
            }
          }
        }
      }
      if(frequency === 'customized'){
        return {
          startDate:startDate,
          time: 1,
          frequency:frequency,
          day:date.join(',')
        }
      }else{
        return {
          startDate:startDate,
          time: dates.length,
          frequency:frequency,
          day: ''
        }
      }
    },
    closeSelectRecord(records){
      if (records.length !== 0) {
        this.form.invoiceRecordId = records[0]
      }
      this.showRecordDialog = false
    },
    closeSelectMail(mails){
      if (mails.length !== 0) {
        this.form.mailInfoId = mails[0]
      }
      this.showMailDialog = false
    },
    getRecord(){
      this.showRecordDialog = true
    },
    getMail(){
      this.showMailDialog = true
    },
    generateDates(startDate, frequency, occurrences, date) {
      let result = {};
      if(frequency === 'customized'){
        date.split(',').forEach(item=>{
          let date = padDate(item)
          result[date] = false
        })
      }else{
        let currentDate = new Date(startDate);
        for (let i = 0; i < occurrences; i++) {
          result[currentDate.toISOString().split('T')[0]] = false
          switch (frequency) {
            case 'day':
              currentDate.setDate(currentDate.getDate() + 1);
              break;
            case 'week':
              currentDate.setDate(currentDate.getDate() + 7);
              break;
            case 'month':
              currentDate.setMonth(currentDate.getMonth() + 1);
              break;
            default:
              this.$messageUi.error('不支持的频率类型')
          }
        }
      }
      return result;
    },
    handle(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.startDate = padDate(this.form.startDate)
          this.form.remindersTimes = this.generateDates(this.form.startDate,this.form.frequency,this.form.time,this.form.day)
          if(this.selectType === 'add'){
            addReminders(this.form).then(res=>{
              if(res.code===200){
                this.$messageUi.success('添加日历提醒成功')
                this.$emit('submit','confirm')
              }
            }).catch(err=>{
              this.$messageUi.error('添加日历提醒失败，请检查')
            })
          }else{
            this.$confirmUi('修改后所有计划日期的完成情况将重置为待完成, 是否继续?', '信息', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              editReminders(this.form).then(res=>{
                if(res.code===200){
                  this.$messageUi.success('修改日历提醒成功')
                  this.$emit('submit','confirm')
                }
              }).catch(err=>{
                this.$messageUi.error('修改日历提醒失败，请检查')
              })
            }).catch(() => {

            });
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
